import { createFileRoute } from '@tanstack/react-router'
import EditionAssets from 'Edition/components/sections/Assets/EditionAssets'
import { claimTypesEnum } from 'User/utils/claims'

import { Guard } from '../../../../-guard'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/assets')({
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_asset]}>
            <EditionAssets />
        </Guard>
    ),
})
